/* BHALLO — popup de captura via WhatsApp + abinha fixa no canto.
   O popup abre sozinho na entrada (1x por visitante).
   Depois de fechado, a abinha azul reabre a qualquer momento. */
(function () {
  var KEY_POPUP = 'bhallo:popup';
  var KEY_TAB = 'bhallo:tab';
  // 1,5s: tempo pra pagina pintar antes. Se abrir em 0, parece site quebrado.
  var DELAY = 1500;

  function get(k) {
    try { return localStorage.getItem(k) === '1'; } catch (e) { return false; }
  }
  function set(k) {
    try { localStorage.setItem(k, '1'); } catch (e) {}
  }

  function init() {
    var pop = document.getElementById('BhalloPopup');
    if (!pop) return;

    var timer;

    function abrir() {
      clearTimeout(timer);
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
    }

    function fechar() {
      pop.classList.remove('is-open');
      set(KEY_POPUP);
      setTimeout(function () { pop.hidden = true; }, 250);
    }

    // abre sozinho na entrada — so pra quem ainda nao viu
    if (!get(KEY_POPUP)) {
      timer = setTimeout(abrir, DELAY);
    }

    var close = document.getElementById('BhalloPopupClose');
    var no = document.getElementById('BhalloPopupNo');
    var overlay = document.getElementById('BhalloPopupOverlay');
    var cta = document.getElementById('BhalloPopupCta');

    if (close) close.addEventListener('click', fechar);
    if (no) no.addEventListener('click', fechar);
    if (overlay) overlay.addEventListener('click', fechar);
    if (cta) cta.addEventListener('click', function () { set(KEY_POPUP); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) fechar();
    });

    // ---- abinha fixa ----
    var tab = document.getElementById('BhalloTab');
    if (!tab) return;

    if (get(KEY_TAB)) {
      tab.hidden = true; // o cliente escondeu antes
      return;
    }

    var tabBtn = document.getElementById('BhalloTabBtn');
    var tabX = document.getElementById('BhalloTabX');

    if (tabBtn) {
      // reabre quantas vezes o cliente quiser
      tabBtn.addEventListener('click', abrir);
    }
    if (tabX) {
      tabX.addEventListener('click', function (e) {
        e.stopPropagation();
        tab.hidden = true;
        set(KEY_TAB);
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
